export default "__VITE_ASSET__Cs8LvdFr__"